import { GetEmployeeListApi } from "../../api/request/businessTask/businessTask";

const defaultRender = (value) => (value ? value : '--');

 const getEmployeeList = async () => {
    try {
      const { data } = await GetEmployeeListApi();
      if (data.status) {
          return data?.data?.map((item) => {
            return { value: item?.name, text: item?.name };
          })
      }
    } catch (error) { }
  }

const columns = [
    {
        title: 'Name',
        dataIndex: 'client_name',
        render: defaultRender,
    },
    {
        title: 'Verify Doc',
        dataIndex: 'task_1',
        render: defaultRender,
        filters: await getEmployeeList(),
        onFilter: (value, record) => {
            return record?.task_1?.includes(value)
        },
    },
    {
        title: 'Prepare Tax',
        dataIndex: 'task_2',
        render: defaultRender,
        filters: await getEmployeeList(),
        onFilter: (value, record) => {
            return record?.task_2?.includes(value)
        },
    },
    {
        title: 'Review Tax',
        dataIndex: 'task_3',
        render: defaultRender,
        filters: await getEmployeeList(),
        onFilter: (value, record) => {
            return record?.task_3?.includes(value)
        },
    },
    {
        title: 'Follow Up',
        dataIndex: 'task_4',
        render: defaultRender,
        filters: await getEmployeeList(),
        onFilter: (value, record) => {
            return record?.task_4?.includes(value)
        },
    },
    {
        title: 'E-file',
        dataIndex: 'task_5',
        render: defaultRender,
        filters: await getEmployeeList(),
        onFilter: (value, record) => {
            return record?.task_5?.includes(value)
        },
    },
];

export default columns;